import { Bars } from 'react-loader-spinner';

export const LoadingBar = ({
  height = '25',
  width = '25',
  color = '#00D090',
  ariaLabel = 'bars-loading',
  wrapperStyle = {},
  wrapperClass = 'md:pt-0 sm:pt-2 justify-center',
  visible = true,
}) => {
  return (
    <Bars
      height={height}
      width={width}
      color={color}
      ariaLabel={ariaLabel}
      wrapperStyle={wrapperStyle}
      wrapperClass={wrapperClass}
      visible={visible}
    />
  );
};
